module.exports = __webpack_public_path__ + "img/team_icon_grey.5a66c4a5.svg";